import(/* webpackMode: "eager" */ "/home/janab/freelance/alfamall/comverse-baseapp-next/components/FixedButton/FixedButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/alfamall/comverse-baseapp-next/components/SEO/FBPixels/FBPixels.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/alfamall/comverse-baseapp-next/components/SEO/GTManager/GTManager.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/alfamall/comverse-baseapp-next/components/WhatsAppButton/WhatsAppButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/alfamall/comverse-baseapp-next/layouts/LayoutsWrapper/LayoutsWrapper.jsx");
;
import(/* webpackMode: "eager" */ "/home/janab/freelance/alfamall/comverse-baseapp-next/node_modules/next/dist/client/script.js");
